module.exports = __webpack_public_path__ + "static/scale-model-of-allen-convention-&-visitors-bureau-in-allen-texas-0848ef5ba7c7c31fc5ce4d5a4094b113.png";